import {inject, Injectable} from '@angular/core';
import {ApiResourceLocation, SOFTLINE_SERVICE_HTTP} from '@softline/core';
import {Observable} from 'rxjs';
import {SOFTLINE_API_PRODUKTIONSAUFTRAG_UPDATE_STATUS} from '../produktionsauftrag.api';
import {KopfPr} from '../types/produktionsauftrag';

@Injectable()
export class KopfprService {
  readonly httpService = inject(SOFTLINE_SERVICE_HTTP);

  updateStatus(params: { kopfpr: KopfPr, status: string; }): Observable<any> {
    const location: ApiResourceLocation = {
      path: SOFTLINE_API_PRODUKTIONSAUFTRAG_UPDATE_STATUS,
      pathParams: {
        idkopfpr: params.kopfpr.id,
      }
    }

    return this.httpService.patch(location, {
      status: params.status
    });
  }
}
